import {FC, useEffect} from "react";
import {useLexicalComposerContext} from "@lexical/react/LexicalComposerContext";

interface FocusBlurPluginProps {
    onFocus?: () => void;
    onBlur?: () => void;
}

const FocusBlurPlugin: FC<FocusBlurPluginProps> = ({onFocus, onBlur}) => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        const rootElement = editor.getRootElement();
        if (!rootElement) {
            return;
        }

        const wrapperElement = rootElement.closest("[data-rich-text-wrapper]") as HTMLElement | null;

        const handleFocus = () => {
            onFocus?.();
        };

        const handleBlur = (event: FocusEvent) => {
            const relatedTarget = event.relatedTarget as HTMLElement | null;

            if (relatedTarget && wrapperElement?.contains(relatedTarget)) {
                return;
            }

            onBlur?.();
        };

        rootElement.addEventListener("focus", handleFocus, true);
        rootElement.addEventListener("blur", handleBlur, true);

        return () => {
            rootElement.removeEventListener("focus", handleFocus, true);
            rootElement.removeEventListener("blur", handleBlur, true);
        };
    }, [editor, onFocus, onBlur]);

    return null;
};

export default FocusBlurPlugin;
